export default __webpack_public_path__ + "static/media/guide@2x.1399353c.png";